import React, {useEffect, useRef, useState} from "react";
import {Button, Grid, TablePagination, TextField, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {deleteAllRoomsPerHospital, getAllHospitalRoomsPerHospital, onboardRoomViaExcel} from "../utils/API";
import Header from "../components/core/Header";
import CustomTable from "../components/core/CustomTable";
import moment from "moment/moment";
import {ArrowForward} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    LeftContainer: {
        //margin:theme.spacing(3),
        display: "flex",
        flexDirection: "column !important",
        flexWrap: "warp",
        alignItems: "center",
        padding: theme.spacing(2),
        background: "#4D88FE",
        minHeight: "100vh",
        minWidth: "50vh",
    },
    paper: {
        margin: theme.spacing(8),
        // marginBottom: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(3),
    },
    avatar: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        width: "12rem",
        borderRadius: "3px",
        marginBottom: theme.spacing(2),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
        color: "#fff",
    },
    submit: {
        marginTop: theme.spacing(2),
    },
    branding: {
        //fontFamily: 'AvantGardeRegular',
        color: "#000",
    },
}));

const tableColumn = [
    /*{
        title: "Se. No.",
        field: "id",
    },*/
    {
        title: "Room Id",
        field: "id",
    },
    {
        title: "Hospital Service Type",
        field: "hospitalRoomName"
    },
    {
        title: "Tariff (in ₹)",
        field: "roomTariffDay"
    },
    {
        title: "Galaxy Room Type/Insurer",
        field: "insurerRoomCategory",
    },
    {
        title: "Vitraya Room Type",
        field: "vitrayaRoomType",
    },
    {
        title: "Is single room Private AC",
        field: "privateAc",
    },
    {
        title: "Created/Updated Date",
        field: "updateTime",
        render: (rowData) =>
            rowData &&
            rowData.updateTime && (
                <span>
              {" "}
                    {moment(rowData.updateTime)
                        .tz("Asia/Kolkata")
                        .format("DD- MM -YYYY, hh:mm:ss a")}{" "}
            </span>
            ),
    },
];

// is null or empty
function isEmpty(value) {
    return value === null || value === undefined || value === "";
}

function OnBoardHosp() {
    // const {setShowSnackbar} = props;
    const classes = useStyles();
    const [tableData, setTableData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [totalTableCount, setTotalTableCount] = useState(50);
    const [page, setPage] = useState(0);
    const [roomDocument, setRoomDocument] = useState([]);
    const [hospitalCode, setHospitalCode] = useState("");
    const fileInputRef = useRef(null);
    const [error, setError] = useState("");
    const [showSanckBar, setShowSnackbar] = useState({
        status: false,
        message: "",
        severity: "",
    });

    useEffect(() => {
    }, [pageSize, page]);
    useEffect(() => {
        roomDocument.length !== 0 && handleRoomsFileUpload();
    }, [roomDocument]);

    const getRoomsWithHospitalCode = async (event) => {
        event.preventDefault();
        if (!isEmpty(hospitalCode)) {
            await fetchData(hospitalCode);
        } else {
            setError("Hospital code is required");
        }
    };

    const fetchData = async (code) => {
        console.log('inside fetch method');
        let response = await getAllHospitalRoomsPerHospital(code);
        let isSuccess = response !== null && response.success;
        let isDataPresent = response !== null /*&& response.status*/ && response?.data !== null;
        console.log(isSuccess, isDataPresent);
        setTableData( isSuccess? response?.data : []);
        setTotalTableCount(isSuccess && isDataPresent ? response.data?.length : 0);
    };

    const deleteAllRoomsAfterHospital = async (event) => {
        event.preventDefault();
        if (!isEmpty(hospitalCode)) {
            await deleteRoomData(hospitalCode);
        } else {
            setError("Hospital code is required");
        }
    };

    const deleteRoomData = async (hospitalCode) => {
        console.log('inside fetch method');
        let response = await deleteAllRoomsPerHospital(hospitalCode);
        setTableData([]);
        setTotalTableCount(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleTextInputChange = (event) => {
        console.log(event.target.value);
        setHospitalCode(event.target.value);
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const handleFileChange = (event) => {
        const files = event.target.files[0];
        files.length !== 0 && setRoomDocument(files);
        // files.length !== 0 && handleRoomsFileUpload();
    };
    const handleRoomsFileUpload = async () => {
        const response = await onboardRoomViaExcel(roomDocument);
        response.success === true &&
        setShowSnackbar({
            status: true,
            message: response.data,
            severity: "success",
        });
        await fetchData(hospitalCode);
    };

    return (
        <Grid container>
            <Header/>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    border: "1px solid",
                    padding: 10,
                    height: "1.5rem",
                    marginLeft: 30,
                    marginTop: 30,
                    background: "#000",
                    cursor: "pointer",
                }}
            >
                <div style={{color: "#fff"}}>
                    <ArrowBackIcon/>
                </div>

                <Link to={"/"} style={{textDecoration: "none", color: "#fff"}}>
                    {" "}
                    Go Back
                </Link>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    border: "1px solid",
                    padding: 10,
                    height: "1.5rem",
                    marginLeft: 30,
                    marginTop: 30,
                    background: "#000",
                    cursor: "pointer",
                }}
            >
                <Link to={"/onboarding-hospital"} style={{textDecoration: "none", color: "#fff"}}>
                    {" "}
                    Go To Onboard Hospital
                </Link>
                <div style={{color: "#fff"}}>
                    <ArrowForward/>
                </div>
            </div>
            <Grid
                item
                style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "column",
                    width: "100vw",
                }}
            >
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    padding={3}
                >
                    <Typography
                        variant="body1"
                        style={{
                            marginBottom: "20px",
                            fontSize: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Onboard Rooms For Hospitals
                    </Typography>
                </Grid>

                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="hospitalCode"
                        label="Enter Hospital Code"
                        type="text"
                        id="hospitalCode"
                        autoComplete="code"
                        value={hospitalCode}
                        onChange={handleTextInputChange}
                    />
                    <Typography variant="body1" color="error">
                        {error}
                    </Typography>

                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={getRoomsWithHospitalCode}
                                disabled={hospitalCode.length <= 4}
                                style={{marginTop: "20px"}}
                            >
                                {"Fetch Rooms"}
                            </Button>
                        </Grid>
                        <Grid item lg md xl>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                // onClick={(event) => getRoomsWithHospitalCode(event)}
                                onClick={handleButtonClick}
                                disabled={hospitalCode.length <= 4}
                                style={{marginTop: "20px"}}
                            >
                                {"Onboard Rooms - Upload"}
                            </Button>
                            <input
                                type="file"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                //multiple
                                hidden
                                data-testid="uploadDoc"
                                id="upload-document"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                // setShowSnackbar={setShowSnackbar}
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={(event) => deleteAllRoomsAfterHospital(event)}
                                disabled={hospitalCode.length <= 4}
                                style={{marginTop: "20px"}}
                            >
                                {"Delete Rooms"}
                            </Button>
                        </Grid>
                    </Grid>
                </form>

                <TablePagination
                    rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
                    colSpan={3}
                    count={totalTableCount}
                    rowsPerPage={pageSize}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Claims per Page"
                />
                <CustomTable
                    tableData={tableData}
                    tableColumns={tableColumn}
                    selection={false}
                    noStickyHeader={true}
                />

                {/*<TablePagination
                    rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
                    colSpan={3}
                    count={parseInt(localStorage.getItem("totalTableCount"))}
                    rowsPerPage={pageSize}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Claims per Page"
                />*/}
            </Grid>
        </Grid>
    );
}

export default OnBoardHosp;
